import React, { ReactNode, forwardRef } from "react";
import { Box, Typography } from "@mui/material";

interface PrintableContentProps {
  children: ReactNode;
  id: string;
  printTitle?: string;
  printSubtitle?: string;
  sx?: Record<string, unknown>;
}

const PrintableContent = forwardRef<HTMLDivElement, PrintableContentProps>(
  ({ children, id, printTitle, printSubtitle, sx }, ref) => {
    return (
      <Box id={id} ref={ref} sx={{ width: "100%", ...sx }}>
        {/* Print-only header */}
        {(printTitle || printSubtitle) && (
          <Box
            sx={{
              display: "none",
              "@media print": {
                display: "block",
                textAlign: "center",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid #000"
              }
            }}
          >
            {printTitle && (
              <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
                {printTitle}
              </Typography>
            )}
            {printSubtitle && (
              <Typography sx={{ fontSize: "13px" }}>{printSubtitle}</Typography>
            )}
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            width: "100%",

            "@media print": {
              maxWidth: "210mm",
              margin: "0 auto",
              padding: "12mm",
              color: "#000",

              // Hide UI actions only
              "& button, & [role='button'], & .MuiIconButton-root": {
                display: "none !important"
              },

              "& .MuiPaper-root": {
                boxShadow: "none !important"
              },

              /* 🔒 FREEZE key-value rows */
              "& .kv-row": {
                display: "grid !important",
                gridTemplateColumns: "1fr auto",
                columnGap: "16px",
                alignItems: "baseline",
                width: "100%"
              },

              "& .kv-row > *:last-child": {
                textAlign: "right",
                whiteSpace: "nowrap"
              }
            }
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }
);

PrintableContent.displayName = "PrintableContent";

export default PrintableContent;
